export default __webpack_public_path__ + "static/media/General's Vambraces of the Ascending Kingdom.1d3ac4e7.jpg";